import { useState } from "react";
import "./styles/LoginPage.css";
import { useNavigate } from "react-router-dom";
import logo from "/assets/logo.svg";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const renderFloatLabelInput = (
    label,
    type,
    name,
    id,
    value,
    onChange,
    required = true,
    autoComplete = "off"
  ) => (
    <div className={`float-label-wrapper ${errorMessage ? "error" : ""}`}>
      <input
        type={type}
        id={id}
        name={name}
        value={value || ""}
        onChange={onChange}
        className="float-input"
        required={required}
        placeholder=" "
        autoComplete={autoComplete}
      />
      <label htmlFor={id} className="float-label">
        {label} {required && <span className="required-star"> *</span>}
      </label>
    </div>
  );

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/check-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.status === 200) {
        const phoneForgot = await response.json();
        sessionStorage.setItem("phoneForgot", JSON.stringify(phoneForgot));
        navigate("/forgotpassword/OTP");
      } else if (response.status === 404) {
        setErrorMessage(`ไม่พบ ${email} ในระบบ`);
        setEmail("");
      } else {
        setErrorMessage("เกิดข้อผิดพลาด");
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("เกิดข้อผิดพลาดในการส่งคำขอ");
    }
  };

  return (
    <div className="background-image">
      <div className="container">
        <form className="login-form" onSubmit={handleForgotPasswordSubmit}>
          <div className="logo">
            <img src={logo} alt="Logo" style={{ marginRight: "8px" }} />
          </div>

          <div className="forgotPassword">
            <h2>ลืมรหัสผ่าน</h2>
            <p>กรอกอีเมล</p>

            {renderFloatLabelInput(
              "อีเมล",
              "email",
              "email",
              "email",
              email,
              (e) => setEmail(e.target.value),
              true,
              "off"
            )}

            {errorMessage && (
              <div className="errorForgotpassword">{errorMessage}</div>
            )}
          </div>

          <button className="ok-branch" type="submit">
            ตกลง
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
